import {
  TRANSACTIONS_TOKU,
  TRANSACTIONS_TOKU_ERROR,
  CLEAN_TRANSACTIONS_TOKU,
  CLEAN_TRANSACTIONS_TOKU_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function transactionsTokuReducer(state = initialState, action) {
  switch (action.type) {
    case TRANSACTIONS_TOKU:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case TRANSACTIONS_TOKU_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_TRANSACTIONS_TOKU:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_TRANSACTIONS_TOKU_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
